import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { useBasePath } from '../../../../lib/use-base-path';
import { useSidebarNav } from '../hooks/use-sidebar-nav';
import { NAV_ICONS } from '../components/nav-icons';
import { RailTooltip } from './RailTooltip';
import styles from './RailWhatsapp.module.css';

// "Connect WhatsApp" at the foot of the wide rail (Figma `Sidebar-Menu` 22012:356805), above the credits
// card. It is the rail's `connect-whatsapp` destination drawn as a card, so it appears on the same rule
// (no number on file) and does the same thing (opens the verification dialog over the current page) —
// both decided in useSidebarNav. Collapsed it is the WhatsApp glyph.
export function RailWhatsapp({ collapsed = false }: { collapsed?: boolean }) {
  const basePath = useBasePath();
  const { items } = useSidebarNav();
  const item = items.find((i) => i.id === 'connect-whatsapp');
  if (!item) return null;

  if (collapsed) {
    return (
      <RailTooltip label={item.label}>
        <Link href={item.route} as={item.path} onClick={item.onClick} aria-label={item.label} className={`orion-nav-item ${styles.iconItem}`}>
          {NAV_ICONS['connect-whatsapp']}
        </Link>
      </RailTooltip>
    );
  }
  return (
    <Link href={item.route} as={item.path} onClick={item.onClick} className={styles.card}>
      <span aria-hidden className={styles.logo}>
        <img src={`${basePath}/illustrations/sidebar/whatsapp.png`} alt="" width={16} height={16} />
      </span>
      <span className={styles.label}>{item.label}</span>
      <span aria-hidden className={`${styles.arrow} dir-flip`}>
        <ArrowRight size={16} aria-hidden />
      </span>
    </Link>
  );
}
